import React from 'react';
import { AlertCircle, X, Info } from 'lucide-react';
import { apiClient } from '../../utils/api';
import { Button } from '../ui/button';

export function MockModeBanner() {
  const [isVisible, setIsVisible] = React.useState(true);
  const [isDismissed, setIsDismissed] = React.useState(() => {
    // Check if user has dismissed it in this session
    return sessionStorage.getItem('mockModeBannerDismissed') === 'true';
  });
  
  const isMockMode = apiClient.isMockMode();

  if (!isMockMode || isDismissed) {
    return null;
  }

  const handleDismiss = () => {
    setIsDismissed(true);
    sessionStorage.setItem('mockModeBannerDismissed', 'true');
  };

  return (
    <div className="bg-gradient-to-r from-blue-600 to-blue-700 dark:from-blue-700 dark:to-blue-800 text-white px-4 py-3 relative shadow-md">
      <div className="container mx-auto">
        <div className="flex items-center justify-between gap-4">
          <div className="flex items-center gap-3 flex-1">
            <div className="bg-white/20 p-2 rounded-full">
              <Info className="h-5 w-5" />
            </div>
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-1">
                <span className="font-semibold text-sm">🎭 Demo Mode Activo</span>
                <span className="px-2 py-0.5 bg-white/20 rounded-full text-xs">
                  Datos Simulados
                </span>
              </div>
              <p className="text-sm text-white/90">
                La aplicación funciona con datos de prueba. Configura{' '}
                <span className="font-semibold">VITE_API_BASE_URL</span> en el archivo{' '}
                <span className="font-semibold">.env</span> para conectar al servidor real.
              </p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleDismiss}
            className="text-white hover:text-white hover:bg-white/10 h-8 w-8 p-0 shrink-0"
          >
            <X className="h-4 w-4" />
            <span className="sr-only">Cerrar</span>
          </Button>
        </div>
      </div>
    </div>
  );
}